import React from 'react'
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      <div className="upperfooter">
        <a href="/cityu-hongkong/" className="footer_logo">
          <img src="https://static.igem.wiki/teams/5334/bevatech-logo-color-new.png" className="logo_footer" alt="logo" />
        </a>
        <div className="contact_us">

          <div className="contuct_down">
            <a target="_blank" href="mailto:cityuigem2024@gmail.com" className="contact_us_link">
              Contact Us
              <br />
              <br />
              <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/email-icon-1.png" alt="" /><br /><br /><span></span>
            </a>

            <a target="_blank" href="https://www.linkedin.com/company/igem-babak/" className="contact_us_link">
              Let's Connect
              <br />
              <br />
              <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/linkedin-short.png" alt="" /><br /><br /><span></span>
            </a>

            <a target="_blank" href="https://www.instagram.com/igem_cityu/" className="contact_us_link">
            Follow Us
            <br />
              <br />
              <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/ig-icon-1.png" alt="" /><br /><br /><span></span>
            </a>

            <a target="_blank" href="https://www.youtube.com/@CityUiGEM2024" className="contact_us_link">
              Stay Tuned
              <br />
              <br />
              <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/youtube-logo.png" alt="" /><br /><br /><span></span>
            </a>






          </div>
        </div>

      </div>
      <br></br>
    </footer>
  )
}
